import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { SlaDashboardData } from "../../../components/sla/slaTypes";

type LoadSlaDashboardState = {
  loading: boolean;
  data: SlaDashboardData | null;
  error: unknown;
};

const initialState: LoadSlaDashboardState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "load-sla-dashboard",
  initialState,
  reducers: {
    initLoadSlaDashboard: () => {
      return { ...initialState };
    },
    startLoadSlaDashboard: (state) => {
      state.loading = true;
      state.data = null;
      state.error = null;
    },
    successLoadSlaDashboard: (
      state,
      action: PayloadAction<SlaDashboardData>,
    ) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorLoadSlaDashboard: (state, action: PayloadAction<unknown>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initLoadSlaDashboard,
  startLoadSlaDashboard,
  successLoadSlaDashboard,
  errorLoadSlaDashboard,
} = dataSlice.actions;

export default dataSlice.reducer;
